// src/pages/admin/CourseCreate.js
import React from 'react';
import { Form, Input, Button, message } from 'antd';
import { useNavigate } from 'react-router-dom';

const CourseCreate = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const onFinish = async (values) => {
    try {
      // Replace with your actual API call (e.g., axios.post('/api/courses', values))
      console.log('Creating course:', values); // Simulated API call
      message.success('Course created successfully');
      navigate('/admin/courses-manage');
    } catch (error) {
      message.error('Failed to create course');
      console.error(error);
    }
  };

  return (
    <div style={{ padding: 24 }}>
      <h1>Add New Course</h1>
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
      >
        <Form.Item
          name="name"
          label="Name"
          rules={[{ required: true, message: 'Please enter the course name' }]}
        >
          <Input placeholder="Enter course name" />
        </Form.Item>
        <Form.Item
          name="description"
          label="Description"
          rules={[{ required: true, message: 'Please enter a description' }]}
        >
          <Input.TextArea placeholder="Enter course description" rows={4} />
        </Form.Item>
        <Form.Item
          name="status"
          label="Status"
          rules={[{ required: true, message: 'Please enter the status' }]}
        >
          <Input placeholder="e.g., Active or Draft" />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            Create Course
          </Button>
          <Button style={{ marginLeft: 8 }} onClick={() => navigate('/admin/courses-manage')}>
            Cancel
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default CourseCreate;